"use client";

import { IImage } from "@shared/cms";
import { imageFallback } from "@shared/utils";
import Image from "next/image";

export function VacancyHeaderCoverSection({ coverBackground }: { coverBackground?: IImage }) {
  return (
    <div className="w-full h-36 sm:h-60 relative">
      <div className="w-full h-full bg-blue-500">
        {coverBackground && (
          <Image
            src={coverBackground.url}
            alt={coverBackground.alternativeText || coverBackground.name}
            className="w-full h-full object-center object-cover mix-blend-luminosity"
            width={coverBackground.width || 1440}
            height={coverBackground.height || 240}
            onError={imageFallback()}
          />
        )}
      </div>
      <div
        className="absolute top-0 left-0 w-full h-full"
        style={{
          background: "linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0.1) 1072.08%)",
        }}
      ></div>
    </div>
  );
}
